export default {
  messages: [],
  online: 0,
  isProsecc: false,
}